(() => {
  const HOVER_OPEN_DELAY = 100;
  const HOVER_CLOSE_DELAY = 200;

  const megaMenu = document.getElementById('c-mega-menu');
  if (!megaMenu) return;

  const categoryItems = document.querySelectorAll('[data-mega-item]');
  if (!categoryItems.length) return;

  // FB#11: メガメニュー展開中はヘッダー下段（SELL等のナビ行）を隠し、
  // その高さぶんメガメニューを引き上げてカテゴリ行の直下に見せる
  const bottomBar = document.querySelector('.c-header__bottom-bar');

  function collapseBottomBar() {
    if (!bottomBar) return;
    megaMenu.style.marginTop = `-${bottomBar.offsetHeight}px`;
  }

  function restoreBottomBar() {
    if (!bottomBar) return;
    megaMenu.style.marginTop = '';
  }

  let openTimer = null;
  let closeTimer = null;
  let activeCategory = null;

  function getActiveTrigger() {
    if (!activeCategory) return null;
    const activeItem = [...categoryItems].find((item) => item.dataset.megaItem === activeCategory);
    return activeItem ? activeItem.querySelector('[aria-expanded]') : null;
  }

  function hasFocusWithinMenu() {
    const activeElement = document.activeElement;
    if (!activeElement) return false;

    return megaMenu.contains(activeElement) || [...categoryItems].some((item) => item.contains(activeElement));
  }

  function clearTimers() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
  }

  function openCategory(key) {
    clearTimers();
    const panel = document.getElementById(`c-mega-${key}`);
    if (!panel) return;

    if (activeCategory && activeCategory !== key) {
      closeImmediate();
    }

    activeCategory = key;
    collapseBottomBar();
    megaMenu.setAttribute('aria-hidden', 'false');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('c-mega-menu-open');

    categoryItems.forEach((item) => {
      const trigger = item.querySelector('[aria-expanded]');
      if (!trigger) return;
      const isActive = item.dataset.megaItem === key;
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  function focusFirstPanelItem(key) {
    const panel = document.getElementById(`c-mega-${key}`);
    if (!panel) return;

    const focusTarget = panel.querySelector('a[href], button:not([disabled])');
    if (focusTarget) {
      focusTarget.focus();
    }
  }

  function closeImmediate() {
    if (activeCategory) {
      const panel = document.getElementById(`c-mega-${activeCategory}`);
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }
    megaMenu.setAttribute('aria-hidden', 'true');
    categoryItems.forEach((item) => {
      const trigger = item.querySelector('[aria-expanded]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    activeCategory = null;
    restoreBottomBar();
    document.body.classList.remove('c-mega-menu-open');
  }

  function scheduleOpen(key) {
    clearTimers();
    openTimer = setTimeout(() => openCategory(key), HOVER_OPEN_DELAY);
  }

  function scheduleClose() {
    clearTimers();
    closeTimer = setTimeout(() => {
      if (!hasFocusWithinMenu()) {
        closeImmediate();
      }
    }, HOVER_CLOSE_DELAY);
  }

  function scheduleCloseAfterFocusChange() {
    clearTimers();
    closeTimer = setTimeout(() => {
      if (!hasFocusWithinMenu()) {
        closeImmediate();
      }
    }, 0);
  }

  categoryItems.forEach((item) => {
    const key = item.dataset.megaItem;
    if (!key) return;
    const trigger = item.querySelector('[aria-expanded]');

    item.addEventListener('mouseenter', () => scheduleOpen(key));
    item.addEventListener('mouseleave', () => scheduleClose());

    item.addEventListener('focusin', () => openCategory(key));
    item.addEventListener('focusout', () => scheduleCloseAfterFocusChange());

    if (!trigger) return;

    trigger.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;

      e.preventDefault();
      openCategory(key);
      focusFirstPanelItem(key);
    });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      // FB#17: 開いているカテゴリを再クリックしたら閉じる（トグル）
      if (activeCategory === key) {
        clearTimers();
        closeImmediate();
        return;
      }

      openCategory(key);
    });
  });

  megaMenu.addEventListener('mouseenter', () => clearTimers());
  megaMenu.addEventListener('mouseleave', () => scheduleClose());
  megaMenu.addEventListener('focusin', () => clearTimers());
  megaMenu.addEventListener('focusout', () => scheduleCloseAfterFocusChange());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && activeCategory) {
      const trigger = getActiveTrigger();
      clearTimers();
      closeImmediate();
      if (megaMenu.contains(document.activeElement) && trigger) {
        trigger.focus();
      }
    }
  });

  document.addEventListener('click', (e) => {
    if (!activeCategory) return;
    const isInsideMenu = megaMenu.contains(e.target);
    const isInsideTrigger = [...categoryItems].some((item) => item.contains(e.target));
    if (!isInsideMenu && !isInsideTrigger) {
      clearTimers();
      closeImmediate();
    }
  });

  megaMenu.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-mega-tab]');
    if (!tab) return;

    const panelId = tab.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (!panel) return;

    const catPanel = tab.closest('.c-mega-menu__cat');
    if (!catPanel) return;

    catPanel.querySelectorAll('[data-mega-tab]').forEach((btn) => {
      btn.setAttribute('aria-selected', 'false');
      btn.classList.remove('c-mega-menu__tab--active');
    });
    catPanel.querySelectorAll('.c-mega-menu__panel').forEach((p) => {
      p.hidden = true;
    });

    tab.setAttribute('aria-selected', 'true');
    tab.classList.add('c-mega-menu__tab--active');
    panel.hidden = false;
  });
})();
